import Link from "next/link";
import { type ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * The footer's column entries. Seventeen of them are links and one — cookie
 * preferences — opens a dialog, and they had the same three classes copied
 * either side of that difference, which is why only one of them was ever
 * going to get a hover.
 *
 * The resting 70% is the design's; hover takes it to full on the shared
 * colour timing.
 */
type FooterLinkBaseProps = {
  onClick: () => void;
  className?: string;
  children: ReactNode;
};

type FooterLinkProps = FooterLinkBaseProps &
  (
    | { href: string; external?: boolean }
    | { href?: undefined; external?: never }
  );

const FOOTER_LINK_CLASSES =
  "text-left font-ppMori text-paragraph-md opacity-70 transition-opacity duration-quick ease-out-strong hover:opacity-100 motion-reduce:transition-none";

const FooterLink = ({
  onClick,
  className,
  children,
  ...props
}: FooterLinkProps) => {
  const classes = cn(FOOTER_LINK_CLASSES, className);

  if (props.href !== undefined) {
    return (
      <Link
        href={props.href}
        onClick={onClick}
        className={classes}
        {...(props.external === true
          ? { target: "_blank", rel: "noopener noreferrer" }
          : {})}
      >
        {children}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes}>
      {children}
    </button>
  );
};

export default FooterLink;
